import _extends from "@babel/runtime/helpers/extends";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';

var _ref =
/*#__PURE__*/
___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M49.117 15.654V1.148a1 1 0 0 0-1-1H33.612c-.891 0-1.337 1.078-.707 1.708l4.322 4.322-11.08 10.482a2 2 0 0 1-2.747.002L12.203 6.103l4.01-4.01c.63-.63.183-1.706-.708-1.706H1a1 1 0 0 0-1 1v14.505c0 .891 1.077 1.337 1.707.707l5.467-5.467 13.518 13.197a2 2 0 0 1 .602 1.431v24.037a2 2 0 0 0 2 2h2.96a2 2 0 0 0 2-2V25.76a2 2 0 0 1 .601-1.43l13.402-13.122 5.153 5.154c.63.63 1.707.184 1.707-.707z",
  fill: "#73C4FF"
});

var SvgComponent = function SvgComponent(props) {
  return ___EmotionJSX("svg", _extends({
    width: 50,
    height: 52,
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/faq-other-options.25fbf409.svg";
export { SvgComponent as ReactComponent };